<template>
<div>
  <a-row>
    <a-col :span="20" :offset="2" class="css_container">
      <a-card class="css_card" hoverable>
        <p slot="title" class="css_card_title">Password Reset</p>
        <div v-if="showwhat===1">
          <p style="float:left;text-align:left">Reset your new password below.</p>
          <!-- <p style="float:left;text-align:left">Or contact your team manager.</p> -->
          <a-form :form="form" @submit="onSubmit">
            <a-form-item label="新しいパスワード" :label-col="{ span: 5 }" :wrapper-col="{ span: 6 }">
              <a-input-search :type="typeNewPwd" @search="onChangeStarNewPwd" v-decorator="['newpwd',{rules: [
                { required: true, message: 'Please input your new password!' }
                , {validator: validNewPwd}]}]">
                <a-button slot="enterButton" :icon="eyeNewPwd"></a-button>
              </a-input-search>
            </a-form-item>

            <a-form-item label="もう一度入力ください" :label-col="{ span: 5 }" :wrapper-col="{ span: 6 }">
              <a-input-search :type="typeConfirmPwd" @search="onChangeStarConfirmPwd" v-decorator="['confirmpwd',{rules: [
                { required: true, message: 'Please input your new password again!' }
                , {validator: validConfirmPwd}]}]">
                <a-button slot="enterButton" :icon="eyeConfirmPwd"></a-button>
              </a-input-search>
            </a-form-item>
            <a-form-item>
              <a-button :loading="isLoading" block type="primary" html-type="submit">RESET</a-button>
            </a-form-item>
          </a-form>
        </div>
        <div v-else-if="showwhat===2">
          <p style="float:left;text-align:center">This link has been expired.</p>
        </div>
        <div v-else-if="showwhat===3">
          <p style="float:left;text-align:center">Reset succeed,please login again.</p>
        </div>
        <div v-else-if="showwhat===4">
          <p style="float:left;text-align:center;text-color:red">Error Occured.</p>
          <p style="float:left;text-align:center;text-color:red">{{errorcode}}</p>
          <p style="float:left;text-align:center;text-color:red">{{errormessage}}</p>
        </div>
        <div v-else>
          <a-icon type="sync" spin />
          <span style="float:left;text-align:center">Loading...</span>
        </div>
      </a-card>
    </a-col>
  </a-row>
</div>
</template>

<script>
const p_password_low = /^[0-9a-zA-Z!@#$%^&*?]*(?=.{6,})(?=.*\d)(?=.*[A-Za-z])[0-9a-zA-Z!@#$%^&*?]*$/
const p_password_mid = /^[0-9a-zA-Z!@#$%^&*?]*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z!@#$%^&*?]*$/
const p_password_high = /^[0-9a-zA-Z!@#$%^&*?]*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*?])[0-9a-zA-Z!@#$%^&*?]*$/

export default {
  name: "RestPassword",
  computed: {
    typeNewPwd: {
      get: function() {
        return this.isNewPwdStar ? "password" : "string"
      }
    },
    typeConfirmPwd: {
      get: function() {
        return this.isConfirmPwdStar ? "password" : "string"
      }
    },
    eyeNewPwd: {
      get: function() {
        return this.isNewPwdStar ? "eye" : "eye-invisible"
      }
    },
    eyeConfirmPwd: {
      get: function() {
        return this.isConfirmPwdStar ? "eye" : "eye-invisible"
      }
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  beforeMount() {
    this.resetToken = this.$route.params.token
    this.$logger.d("ResetPassword", "created api", {
      resetToken: this.resetToken
    })
    this.$api.forgotpwdValid({
        token: this.resetToken
      })
      .then(data => {
        let resp = data.data;
        this.$logger.d("RestPassword", "created api", {
          response: resp
        });
        if (resp.error) {
          this.$notification.error({
            message: "エラー:" + resp.error.code,
            description: resp.error.description
          });
          this.errorcode = resp.error.code
          this.errormessage = resp.error.description
          this.showwhat = 4
        } else {
          this.showwhat = 1
        }
        this.isLoading = false;
      })
      .catch(err => {
        this.$logger.e("RestPassword", "created api", {
          error: err
        });
        this.$notification.error({
          message: "エラー",
          description: "サーバ通信エラー"
        });
        this.isLoading = false;
      });
  },
  data() {
    return {
      isLoading: false,
      showwhat: 0,
      email: null,
      resetToken: null,
      errorcode: "",
      errormessage: "",
      newpwd: "",
      confirmpwd: "",
      isNewPwdStar: true,
      isConfirmPwdStar: true
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();

      this.form.validateFields(['pwd', 'newpwd', 'confirmpwd'], {
        force: true
      }, (err, values) => {
        if (!err) {
          this.$logger.d("ChangePwd", "onSubmit", {
            values: values
          });

          this.$api.resetpassword({
              token: this.resetToken,
              pwd_new: values.newpwd,
              pwd_confirm: values.confirmpwd
            }).then(data => {
              let resp = data.data;
              this.$logger.d("ResetPassword", "onSubmit", {
                response: resp
              });
              if (resp.error) {
                this.$notification.error({
                  message: "エラー:" + resp.error.code,
                  description: resp.error.description
                });
              } else {
                this.$notification.success({
                  message: "パスワードをリセットしました"
                });
                this.$store.dispatch("logout");
                this.$router.push({
                  path: "/login"
                });
              }
            })
            .catch(err => {
              this.$logger.e("ChangePwd", "onSubmit", {
                error: err
              });
              this.$notification.error({
                message: "エラー",
                description: "サーバ通信エラー"
              });
            });
        }
      });
    },
    onChangeStarNewPwd() {
      this.isNewPwdStar = !this.isNewPwdStar
    },
    onChangeStarConfirmPwd() {
      this.isConfirmPwdStar = !this.isConfirmPwdStar
    },
    validNewPwd(rule, value, callback) {
      const form = this.form;
      if (value && value === form.getFieldValue('pwd')) {
        return callback("Cannot use the same password")
      }
      if (!p_password_low.test(value)) {
        return callback("invalid password")
      }
      callback();
    },
    validConfirmPwd(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue('newpwd')) {
        return callback("not confirmed");
      }
      callback();
    },
  }
};
</script>
<style scoped>
.css_container {
  margin-top: 100px;
}

.css_card {
  max-width: 500px;
  margin: 0 auto;
}

.css_card_title {
  text-size: 10px;
  margin: 0 0;
  text-align: left;
}
</style>
